import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { get } from 'lodash';

import VerifyPage from './VerifyPage';
import dataFetcher from "../../parts/chore/dataFetcher";
import { openLoginModal, openRegisterModal, openRecoveryModal, openResetModal, openConfirmationModal } from "../../parts/ui/uiActions";
import {
  sendRegistrationEmail
} from 'Parts/session/sessionActions';

const mapStateToProps = state => ({
  locale: state.session.language,
  connectionModalState: state.ui.connectionModalState,
  userTypeId: state.session.userTypeId,
  campaigns: state.campaign.campaigns,
  isBillingConfigured: get(state, 'organization.isBillingConfigured'),
  session: state.session
});

const mapDispatchToProps = dispatch => bindActionCreators({
  openLoginModal,
  openRegisterModal,
  openResetModal,
  openRecoveryModal,
  openConfirmationModal,
  sendRegistrationEmail
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(VerifyPage);
